import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../i18n"; // Ensure i18n is initialized
import Button from "../../components/common/button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getJackpotNumberData } from "../../redux/slices/winnersSlice";
import { clearTickets } from "../../redux/slices/purchaseTicketsSlice";
import { fetchWalletData } from "../../redux/slices/walletSlice";

const LotteryResult = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { jackpotNumber } = useSelector((state) => state.winners);
  const lotteryNumber = jackpotNumber?.number;
  const userId = localStorage.getItem("userID");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getJackpotNumberData());
  }, [dispatch]);

  useEffect(() => {
    // && isNaN(balance)
    if (userId) {
      dispatch(fetchWalletData(userId)); // Fetch wallet data on component mount
    }
  }, [userId, dispatch]);

  const handleNavigate = () => {
    dispatch(clearTickets());
    navigate("/");
  };

  return (
    <>
      {/* Title */}
      <div className="flex justify-center my-2">
        <p className="text-white text-lg sm:text-xl md:text-2xl font-medium text-center">
          {t("lotteryResult.lotteryResult")}
        </p>
      </div>
      {/* <div className="flex justify-start  flex-row gap-6 mt-5 ">
        <MdKeyboardArrowLeft className="text-yellow-500 text-2xl sm:text-3xl font-bold cursor-pointer ml-3" />

        <p className=" text-yellow-400 text-lg sm:text-xl font-normal font-['Tiro Devanagari Hindi'] leading-normal">
          लॉटरी परिणाम
        </p>
      </div> */}
      <div className="flex justify-center items-center flex-col">
        <div className="m-3 ">
          <div className="w-80 text-[#FFBF4D] text-2xl font-normal font-['Tiro Devanagari Hindi'] leading-normal">
            {t("lotteryResult.congratulations")}
          </div>
          <div className="w-80 text-[#FFBF4D] text-xs font-normal font-['Tiro Devanagari Hindi'] leading-none">
            {t("lotteryResult.winnerMessage")}
          </div>
        </div>
        <div className="w-80 h-80 relative bg-black/5">
          <img
            className="w-96 h-80 left-[-40px] top-[-18px] absolute opacity-[70%]"
            alt="coinsbag"
            src="/images/coinsbag.gif"
          />
          <div className="w-72 h-4 left-[16px] top-[160px] absolute text-center text-[#FFBF4D] text-base font-medium font-['Roboto'] leading-snug">
            {t("lotteryResult.lotteryTicket")}
          </div>
          <div className="p-1 left-0 top-0 absolute bg-black/5 rounded-tl-md rounded-br-md flex-col justify-center items-center inline-flex">
            <div className="text-[#FFBF4D] text-xs font-normal font-['Tiro Devanagari Hindi'] leading-none">
              {t("lotteryResult.jackpot")}
            </div>
          </div>
          <img
            className="w-72 h-72 left-[5px] top-[20px] absolute"
            alt="ticket"
            src="/images/ticket.png"
          />
        </div>
        <div className="mx-10">
          <div className="w-80 text-[#FFBF4D] text-xs font-normal font-['Tiro Devanagari Hindi'] leading-none">
            {t("lotteryResult.winningNumber")}
          </div>
          <div className="text-[#FFBF4D] text-5xl font-medium font-['Roboto'] leading-normal">
            {lotteryNumber}
          </div>
        </div>
        {/* <div className="my-5 justify-center items-center inline-flex mx-5">
        <Button text={" परिणाम साझा करें"} />
      </div> */}
        <div className="w-80 ml-7 text-white text-lg font-normal font-['Tiro Devanagari Hindi'] leading-normal">
          {t("lotteryResult.playerCertificate")}
        </div>
        <div className="flex justify-between items-center w-72 my-3">
          <div className="w-56 text-white text-xs font-normal font-['Tiro Devanagari Hindi'] leading-none">
            {t("lotteryResult.happyWinner")}
          </div>
          <div className="flex">
            <span className="text-[#FFBF4D]">★★★★★</span>
          </div>
        </div>
        <div className="flex justify-center items-center ">
          <p className="w-80 text-white text-sm font-normal font-['Tiro Devanagari Hindi'] leading-tight text-center">
            {t("lotteryResult.testimonial")}
          </p>
        </div>
        <div className="my-5 justify-center items-center inline-flex mx-5">
          <Button
            onClick={handleNavigate}
            text={t("lotteryResult.buyMoreTickets")}
          />
        </div>
      </div>
    </>
  );
};

export default LotteryResult;
